<template>
  <div class="none_box">
    <div v-if="info === null && login" class="my_none">
      <div v-if="login">
        您还未登录，请
        <router-link class="my_none_btn" :to="{ name: 'Login' }">登录</router-link>
        账号后查看
      </div>
    </div>
    <div v-else>
      <div v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      class="my_none"></div>
      <div v-if="!loading" class="my_none">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'none',
  props: {
    login: { required: true }, // 是否需要登陆
    loading: { required: true }, // 加载动画开启
    text: { required: true }, // 内容为空时的文字提示
    data: { required: true } // 数据列表
  },
  data () {
    return {
      info: null
    }
  },
  created () {
    this.info = this.$store.state.user.info
  }
}
</script>

<style>
</style>
